import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { ServiceError, useError } from 'Src/network/useError';

import service, { StandardDiscountWithSchedules } from './discountService';

const queryKeys = {
  standardDiscounts: ['POS:GET:StandardDiscounts'],
};

const useQuery_DiscountGetAll = <TData = StandardDiscountWithSchedules[]>(select?: (allDiscounts: StandardDiscountWithSchedules[]) => TData) => {
  const { t } = useTranslation();
  const automatedCoreServieError = useError({ activity: t('discount.errors.getAll') });
  return useQuery<StandardDiscountWithSchedules[], ServiceError, TData>({
    queryKey: queryKeys.standardDiscounts,
    queryFn: async () => {
      try {
        return await service.getAll({});
      } catch (e) {
        throw automatedCoreServieError.parseError(e);
      }
    },
    select,
  });
};

const useQuery_DiscountGetAllMap = () => useQuery_DiscountGetAll((data) => {
  const dscMap = new Map<number, StandardDiscountWithSchedules>();
  data?.forEach((d) => dscMap.set(d.id, d));
  return dscMap;
});

const useDiscount = {
  query: {
    getAll: useQuery_DiscountGetAll,
    map: useQuery_DiscountGetAllMap,
  },
};

export { useDiscount };
